import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { CommonProperties, CommonStyles, Color, FontSize } from '../../styles';
import BaseText from '../BaseText';
import RowView from '../RowView';
import TripStatus from './TripStatus';
import { scale } from '../../utils/scale.utils';

const SlideTitle = ({ image, name, detail, type, style, status, ...rest }) => {
  return (
    <RowView style={[CommonStyles.centerAlignment, style]} {...rest}>
      {image && <Image style={styles.vendor} source={image} />}
      <View style={CommonStyles.flex1}>
        {type ? <BaseText style={styles.header}>{type}</BaseText> : null}
        <BaseText style={styles.title}>{name}</BaseText>
        <RowView style={styles.detail}>
          <BaseText style={CommonStyles.h3}>{detail}</BaseText>
          {status ? <TripStatus status={status.value} label={status.label} /> : null}
        </RowView>
      </View>
    </RowView>
  );
};

const styles = StyleSheet.create({
  header: {
    color: Color.grayText,
    ...CommonProperties.small,
  },
  vendor: {
    resizeMode: 'contain',
    height: scale(45),
    width: scale(45),
    ...CommonProperties.mr4,
  },
  title: {
    ...CommonProperties.h2,
    marginTop: -3,
    marginBottom: -3,
  },
  detail: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

export default SlideTitle;
